import {ReactNode} from 'react';
import {VerifiedPermissionsProvider} from '@flexinet/auth-components';
import {useAuth} from '../hooks/useAuth.ts';
import permissions from '../config/permissions.ts';
import {actions} from '../config/rbac/actions.ts';

// FNP-1723: the shared provider asks AVP only once this app's own AuthContext
// says the session is authenticated. A signed-out visit makes no AVP call, so
// it no longer shows "idToken is required parameter".
export const SessionPermissionsProvider = ({children}: { children?: ReactNode }) => {
    const {status, user} = useAuth()
    return (
        <VerifiedPermissionsProvider
            actions={actions}
            policyStoreId={permissions.policyStoreId}
            region={permissions.region}
            actionType={'Action'}
            enabled={permissions.enabled}
            sessionStatus={status}
            sessionKey={status === 'authenticated' ? user?.userId : undefined}
        >
            {children}
        </VerifiedPermissionsProvider>
    )
}
